import { render, staticRenderFns } from "./EdudashSelect.vue?vue&type=template&id=143035c0&scoped=true&"
import script from "./EdudashSelect.vue?vue&type=script&lang=js&"
export * from "./EdudashSelect.vue?vue&type=script&lang=js&"
import style0 from "./EdudashSelect.vue?vue&type=style&index=0&id=143035c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143035c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
